import { ColumnDefinitionInput, RowType } from '../../../../components/table/types';
import { InstagramCreator } from '@frontend/gql/social/graphql';

export const INSTAGRAM_CREATOR_SEARCH_COLUMN_CONFIG_VERSION = 1;

export const defaultInstagramColumns: ColumnDefinitionInput[] = [
  {
    header: 'Creator',
    id: 'username',
    enableSorting: false,
    enableGlobalFiltering: true,
    rowType: RowType.SOCIAL_MEMBER,
    size: 175,
    minSize: 175,
    maxSize: 200,
    order: 1,
    isFixed: true,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.username,
  },
  {
    header: 'Email',
    id: 'email',
    enableSorting: false,
    enableGlobalFiltering: true,
    rowType: RowType.DEFAULT,
    size: 175,
    minSize: 175,
    maxSize: 200,
    order: 2,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.email,
  },
  {
    header: 'Followers',
    id: 'insights.total.followers',
    enableSorting: false,
    rowType: RowType.NUMBER,
    size: 75,
    minSize: 75,
    maxSize: 100,
    order: 3,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.insights?.total?.followers,
  },
  {
    header: 'Country',
    id: 'country',
    enableSorting: false,
    enableGlobalFiltering: true,
    rowType: RowType.COUNTRY,
    size: 125,
    minSize: 125,
    maxSize: 150,
    order: 4,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.country,
  },
  {
    header: 'Gender',
    id: 'gender',
    enableSorting: false,
    rowType: RowType.CAPITALIZED,
    size: 100,
    minSize: 100,
    maxSize: 125,
    order: 5,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.gender,
  },
  {
    header: 'Age Range',
    id: 'ageBucket',
    enableSorting: false,
    rowType: RowType.AGE_RANGE,
    size: 75,
    minSize: 75,
    maxSize: 100,
    order: 6,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.ageBucket,
  },
  {
    header: 'Engagement',
    id: 'insights.recent.engagement',
    enableSorting: false,
    rowType: RowType.NUMBER,
    size: 100,
    minSize: 100,
    maxSize: 125,
    order: 7,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.insights?.recent?.engagement,
  },
  {
    header: 'Instagram Marketplace',
    id: 'inCreatorMarketplace',
    enableSorting: false,
    rowType: RowType.BOOLEAN,
    hidden: false,
    accessorFn: (row: InstagramCreator) => row.inCreatorMarketplace,
  },
];
